<div class="IropReviewItinerary">
  <div class="IropReviewItinerary-header" (click)="toggleCollapse()">
    <div class="IropReviewItinerary-status">
      <div class="IropReviewItinerary-bullet" [ngClass]="{ 'IropReviewItinerary-bullet--success': type =='new', 'IropReviewItinerary-bullet--warning': type=='old' }">
      </div>
      <span class="fs-24px lh-34px fw-medium-x">
        {{ (type =='new' ? 'srIrops.reviewConfirm.newFlight' : 'srIrops.reviewConfirm.prevFlight') | translate }}
      </span>
    </div>
    <div class="IropReviewItinerary-collapse">
      <span class="fs-24px lh-34px fw-regular">
        {{ (isCollapsed ? 'srIrops.reviewConfirm.showItinerary' : 'srIrops.reviewConfirm.hideItinerary') | translate }} 
        <img alt="" [ngClass]="{ 'rotate': isCollapsed }" src="../../../../../assets/images/arrowUp.svg" />
      </span>
    </div>
  </div>
  <div class="IropReviewItinerary-body" [class.collapsed]="isCollapsed">
    <div class="IropReviewItinerary-dateLeave">
      <span class="fs-24px lh-34px fw-regular">{{ 'srIrops.reviewConfirm.departing' | translate }}</span>
      <span class="fs-36px lh-42px fw-regular">{{ departing | localizedDate: 'EEE. dd MMM.' | capitalize }}</span>
    </div>
    <div class="IropReviewItinerary-route">
      <app-am-flight-itinerary
        [segments]="segments"
        [showDuration]="false"
      ></app-am-flight-itinerary>
    </div>
    <div class="IropReviewItinerary-information">
      <span class="fs-24px lh-30px fw-regular">{{ flightNumber }}</span>
      <span class="fs-24px lh-30px fw-regular">
        <span *ngIf="isNonStop">{{ 'srIrops.reviewConfirm.withOutScales' | translate }}</span>
        <span *ngIf="!isNonStop && connecting == 1">{{ connecting }} {{ 'srIrops.connecting' | translate }}</span>
        <span *ngIf="!isNonStop && connecting > 1">{{ connecting }} {{ 'srIrops.connectings' | translate }}</span>
        <span>, {{ totalTime }}</span><!-- tiempo total de vuelo -->
      </span>
    </div>
  </div>
</div>